import React, { useState, useEffect } from 'react'
import axios from "axios";

function widget_login_banner({ urls, Image }) {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    const { BASE_URL, WIDGETS_BASE } = urls;
    const slug = "instore-login-banner-1/";

    axios.get(`${BASE_URL}${WIDGETS_BASE}${slug}`).then(res => {
      setData(res.data.attributes);
    });
  }, [urls]);

  if (!data) return <div />;
  return (<Image src={data.image.kwargs.url} alt="login_img" />);
}

export default widget_login_banner



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_login_banner/index.js